/**
 * Normalizes a system version string to always have three numeric segments (e.g., "1.0.0").
 * Preserves any suffix (e.g., "-SNAPSHOT-5") that follows the version number.
 *
 * @param inputVersion - The input version string to normalize.
 * @returns The normalized version string with three segments and original suffix.
 *
 * @example
 * normalizeSystemVersion('1')                  // Returns '1.0.0'
 * normalizeSystemVersion('1.2')                // Returns '1.2.0'
 * normalizeSystemVersion('1.2.3')              // Returns '1.2.3'
 * normalizeSystemVersion('1.2.3-SNAPSHOT-5')   // Returns '1.2.3-SNAPSHOT-5'
 * normalizeSystemVersion('1.2-SNAPSHOT-5')     // Returns '1.2.0-SNAPSHOT-5'
 * normalizeSystemVersion('foo')                // Returns 'foo' (unchanged)
 */
export function normalizeSystemVersion(inputVersion: string) {
  // Regex to extract the version and suffix parts
  const versionMatch = inputVersion.match(/^(\d+(?:\.\d+){0,2})(.*)$/);

  if (!versionMatch) return inputVersion; // If input doesn't match expected pattern, return as is

  const [, versionPart, suffixPart] = versionMatch;

  // Split version and pad to three components
  const versionSegments = versionPart.split('.');
  while (versionSegments.length < 3) {
    versionSegments.push('0');
  }

  const normalizedVersion = versionSegments.slice(0, 3).join('.') + suffixPart;

  return normalizedVersion;
}
